export const MAX_LINES = 3
